var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 25C4 23.4087 4.63214 21.8826 5.75736 20.7574C6.88258 19.6321 8.4087 19 10 19H22C23.5913 19 25.1174 19.6321 26.2426 20.7574C27.3679 21.8826 28 23.4087 28 25C28 25.7956 27.6839 26.5587 27.1213 27.1213C26.5587 27.6839 25.7956 28 25 28H7C6.20435 28 5.44129 27.6839 4.87868 27.1213C4.31607 26.5587 4 25.7956 4 25Z",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13C18.4853 13 20.5 10.9853 20.5 8.5C20.5 6.01472 18.4853 4 16 4C13.5147 4 11.5 6.01472 11.5 8.5C11.5 10.9853 13.5147 13 16 13Z",
    stroke: "white",
    strokeWidth: 3.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.1ba14faaf0fe43842b6ed9e05b12bdce.svg";
export { ForwardRef as ReactComponent };